// A per-section element survives Editor reloads without global listeners.
class PebbleRichText extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('.pebble-rich-text__content');
    this.button = this.querySelector('button');
    this.expanded = false;
    this.button.addEventListener('click', this.toggle);
    this.observer = new ResizeObserver(this.measure);
    this.observer.observe(this.content);
    this.measure();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.button?.removeEventListener('click', this.toggle);
  }

  measure = () => {
    const limit = parseInt(getComputedStyle(this).getPropertyValue('--prt-lines'), 10) * 24;
    const collapsible = this.dataset.collapse === 'true' && this.content.scrollHeight > limit + 1;
    this.button.hidden = !collapsible;
    this.classList.toggle('is-collapsed', collapsible && !this.expanded);
    // Links clipped below the preview must not receive invisible keyboard focus.
    for (const link of this.content.querySelectorAll('a')) {
      if (this.classList.contains('is-collapsed')) {
        if (!link.hasAttribute('data-prt-tabindex')) link.dataset.prtTabindex = link.getAttribute('tabindex') ?? '';
        link.setAttribute('tabindex', '-1');
      } else if (link.hasAttribute('data-prt-tabindex')) {
        if (link.dataset.prtTabindex) link.setAttribute('tabindex', link.dataset.prtTabindex);
        else link.removeAttribute('tabindex');
        delete link.dataset.prtTabindex;
      }
    }
  };

  toggle = () => {
    this.expanded = !this.expanded;
    this.button.setAttribute('aria-expanded', String(this.expanded));
    this.button.querySelector('[data-more]').hidden = this.expanded;
    this.button.querySelector('[data-less]').hidden = !this.expanded;
    this.measure();
  };
}
if (!customElements.get('pebble-rich-text')) customElements.define('pebble-rich-text', PebbleRichText);
